import React from 'react'

const Descpt = () => {
  return (
    <>
    <div className="bg-gray-100  w-full justify-center items-center text-center">
      <h1 className="text-4xl font-bold p-6 text-gray-700 text-center">
      Innovative Solutions for a Dynamic World
      </h1>
      </div>
      <div className="bg-gradient-to-b from-gray-100 to-slate-200 px-8 ">
      <p className=' text-gray-600 '>Gemba InfoTech delivers comprehensive services across SAP ECC6.0 and SAP S/4HANA, ensuring seamless implementation, migration, upgrades, and enhancements. We also specialize in developing custom applications and IoT solutions on the SAP Cloud Platform. Our SAP services encompass integration, extension, and more. Our support services are ITSM compliant, with a strong emphasis on effective knowledge management practices to efficiently manage our clients' IT landscapes.</p>
      </div>
      </>
  )
}

export default Descpt